import React, { Component } from "react";
import Button from "react-bootstrap-button-loader";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { showError, showSuccess } from "ReduxErrorBar";
import { openLiveQAExportModal, fetchDownloadLiveQAInfo } from "LiveQAAction";
import { COMMON_FAIL_MESSAGE, MAIN_URL } from "Constants";
import _ from "lodash";
import LocaleStrings from "Languages";
import { DropdownButton, Dropdown } from "react-bootstrap";
var Loader = require("react-loaders").Loader;

class ExportLiveQA extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);

    this.state = { loading: false };
  }

  componentDidMount() {}

  openModal(key) {
    this.setState({ loading: false });
    // this.props.reset();
    this.props.openLiveQAExportModal({ show: true, key: key });
  }

  closeModal() {
    this.props.openLiveQAExportModal({ show: false, key: "" });
  }

  renderLoader = () => {
    return (
      <Loader
        type="line-scale-pulse-out-rapid"
        active
        className="template-loader-div"
      />
    );
  };

  downloadCSV = () => {
    let { session, selectedSession } = this.props;

    this.setState({ loading: true });
    this.props.fetchDownloadLiveQAInfo(session, selectedSession, (response) => {
      if (response.success) {
        this.setState({ loading: false });
        this.props.JSONToCSVConvertor(response.data.result, true);
        this.closeModal();
      } else {
        this.props.showError(COMMON_FAIL_MESSAGE);
        this.setState({ loading: false });
      }
    });
  };

  render() {
    let { loading } = this.state;
    let { handleSubmit, pristine, reset, submitting, invalid, showModal } =
      this.props;

    return (
      <div>
        <div className="dropdown-btn-container">
          <DropdownButton
            className="dropdown-white-btn"
            title={LocaleStrings.button_csv_export}
            key="1"
            id="dropdown-basic-1"
            nocaret="true"
          >
            <Dropdown.Item eventKey="csv" onClick={() => this.openModal("csv")}>
              {LocaleStrings.user_export_option_csv}
            </Dropdown.Item>
            <Dropdown.Item eventKey="pdf" onClick={() => this.openModal("pdf")}>
              {LocaleStrings.user_export_option_pdf}
            </Dropdown.Item>
          </DropdownButton>
        </div>
        <div>
          <Modal
            className="modal-container"
            show={showModal.show === true ? true : false}
            onHide={this.closeModal}
            animation={true}
          >
            {showModal && showModal.show && showModal.key === "csv" ? (
              <form>
                <Modal.Header>
                  <div className="import-modal-title">
                    {LocaleStrings.polls_qa_export_text_export_live_qa}
                  </div>
                  <button
                    type="button"
                    className="i-custom-cross-popup pull-right"
                    onClick={() => this.closeModal()}
                  >
                    <img
                      className="i-custom-small"
                      src="../../style/images/custom-icons/cross-black.png"
                    />
                  </button>
                </Modal.Header>
                <Modal.Body>
                  {/* <div className="import-header">
                                    <div className="import-modal-title">{LocaleStrings.polls_qa_export_text_export_live_qa}</div>
                                    <button type="button" className="close btn-sm btn-close " onClick={() => this.closeModal()} style={{marginTop:-25}}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div> */}

                  <div style={{ textAlign: "center" }}>
                    {loading ? (
                      <div className="">
                        {this.renderLoader()}
                        <div className="loader-info">
                          {
                            LocaleStrings.user_export_text_export_user_csv_downloading
                          }
                        </div>
                      </div>
                    ) : (
                      <div className="">
                        {LocaleStrings.polls_qa_export_text_export_live_qa}
                        <p style={{ fontSize: "x-large" }}>
                          <span style={{ textTransform: "capitalize" }}>
                            {LocaleStrings.you}
                          </span>{" "}
                          {LocaleStrings.have} <b></b>{" "}
                          {LocaleStrings.poll_liveqa_submenu_title1}
                        </p>
                      </div>
                    )}
                  </div>
                </Modal.Body>

                <Modal.Footer>
                  <Button
                    className="btn btn-custom-blue"
                    onClick={this.downloadCSV}
                    loading={loading}
                    disabled={loading}
                    type="submit"
                  >
                    {LocaleStrings.button_download}
                  </Button>
                </Modal.Footer>
              </form>
            ) : showModal && showModal.show && showModal.key === "pdf" ? (
              <div>
                {/* <form onSubmit={handleSubmit(this.downloadPdfF)}> */}
                <Modal.Header>
                  <div className="import-modal-title">
                    {LocaleStrings.polls_qa_export_text_export_live_qa}
                  </div>
                  <button
                    type="button"
                    className="i-custom-cross-popup pull-right"
                    onClick={() => this.closeModal()}
                  >
                    <img
                      className="i-custom-small"
                      src="../../style/images/custom-icons/cross-black.png"
                    />
                  </button>
                </Modal.Header>
                <Modal.Body>
                  {/* <div className="import-header">
                                        <div className="import-modal-title">{LocaleStrings.polls_qa_export_text_export_live_qa}</div>
                                        <button type="button" className="close btn-sm btn-close " onClick={() => this.closeModal()} style={{marginTop:-25}}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div> */}

                  <div>
                    <div style={{ textAlign: "center" }}>
                      {LocaleStrings.user_export_text_export_user_pdf}
                      <p style={{ fontSize: "x-large" }}>
                        <span style={{ textTransform: "capitalize" }}>
                          {LocaleStrings.you}
                        </span>{" "}
                        {LocaleStrings.have} <b></b>{" "}
                        {LocaleStrings.poll_liveqa_submenu_title1}
                      </p>
                    </div>

                    <label className="control-label-top col-md-12"></label>
                    {/* <div className="form-group row">
                                            <div className="col-md-12" style={{fontSize: 13}}>
                                                <Field name="orientation" component="input" type="radio" value="landscape"/> {LocaleStrings.user_export_pdf_form_landscape}
                                                {' '}
                                                <Field  name="orientation" component="input" style={{marginLeft:20}} type="radio" value="portrait" /> {LocaleStrings.user_export_pdf_form_portrait}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-md-12" style={{fontSize: 13}}>
                                                <Field name="fname" component="input" type="checkbox"/> {LocaleStrings.user_export_pdf_form_fname}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-md-12" style={{fontSize: 13}}>
                                                <Field name="lname" component="input" type="checkbox"/> {LocaleStrings.user_export_pdf_form_lname}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-md-12" style={{fontSize: 13}}>
                                                <Field name="company" component="input" type="checkbox"/> {LocaleStrings.company}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-md-12" style={{fontSize: 13}}>
                                                <Field name="designation"  component="input" type="checkbox"/> {LocaleStrings.designation}
                                            </div>
                                        </div> */}
                  </div>
                </Modal.Body>

                <Modal.Footer>
                  <Button
                    className="btn btn-custom-blue"
                    loading={loading}
                    disabled={loading}
                    type="submit"
                  >
                    {LocaleStrings.button_download}
                  </Button>
                </Modal.Footer>
                {/* </form> */}
              </div>
            ) : (
              ""
            )}
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showModal: state.ShowLiveQAExportModal,
    selectedSession: state.selectedSession.resource,
  };
}

export default connect(mapStateToProps, {
  openLiveQAExportModal,
  fetchDownloadLiveQAInfo,
  showError,
  showSuccess,
})(
  // (reduxForm({
  //     form: 'DownloadPdf',
  //     initialValues: { orientation:'landscape', fname:true, lname:true, company:true, designation:true, qr:true}
  // }))
  ExportLiveQA
);
